import React, { useState, useEffect, useCallback } from 'react';
import BeheerdersportaalSidebar from '../components/BeheerdersportaalSidebar';
import api from '../components/api';
import '../css/SchoonmaakPortaal.css';

const STATUS_META = {
  over_tijd: { label: 'Over tijd', cls: 'over_tijd' },
  nieuw: { label: 'Nog niet gedaan', cls: 'nieuw' },
  binnenkort: { label: 'Binnenkort', cls: 'binnenkort' },
  op_schema: { label: 'Op schema', cls: 'op_schema' }
};

const fmtDatum = (iso) => iso
  ? new Date(iso).toLocaleDateString('nl-NL', { day: 'numeric', month: 'short', year: 'numeric' })
  : '';

const SchoonmaakAdmin = () => {
  const [taken, setTaken] = useState([]);
  const [aantalOverTijd, setAantalOverTijd] = useState(0);
  const [link, setLink] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [copied, setCopied] = useState(false);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const r = await api.get('/api/schoonmaak/admin/overzicht');
      setTaken(r.data.taken || []);
      setAantalOverTijd(r.data.aantalOverTijd || 0);
      if (r.data.token) setLink(`${window.location.origin}/schoonmaak/${r.data.token}`);
      setError(false);
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const kopieer = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { /* clipboard niet beschikbaar */ }
  };

  return (
    <BeheerdersportaalSidebar>
      <div className="main-content" style={{ padding: 24 }}>
        <div className="sm-container" style={{ boxShadow: 'none', maxWidth: 720 }}>
          <h1 style={{ color: '#246834', marginTop: 0 }}>Schoonmaak</h1>
          <p className="sm-sub" style={{ marginBottom: 20 }}>
            Voortgang van de schoonmaakleverancier. Hieronder de deelbare link die de schoonmaker
            gebruikt om af te vinken (geen login nodig).
          </p>

          {/* Deelbare link */}
          <div className="sm-taak sm-nieuw" style={{ borderLeftColor: '#246834' }}>
            <div className="sm-taak-head"><span className="sm-titel">🔗 Deelbare link voor de leverancier</span></div>
            <p className="sm-omschr" style={{ wordBreak: 'break-all' }}>{link || '—'}</p>
            <div className="sm-acties">
              <button className="sm-done" onClick={kopieer} disabled={!link}>
                {copied ? 'Gekopieerd ✓' : 'Kopieer link'}
              </button>
              {link && <a className="sm-undo" href={link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', textAlign: 'center' }}>Openen</a>}
            </div>
          </div>

          {loading ? <p>Laden…</p> : error ? (
            <div className="sm-alert error">Kan het overzicht niet laden.</div>
          ) : (
            <>
              {aantalOverTijd > 0
                ? <div className="sm-signaal">⚠ {aantalOverTijd} {aantalOverTijd === 1 ? 'taak is' : 'taken zijn'} over tijd</div>
                : <div className="sm-signaal ok">✓ Alles op schema</div>}

              {taken.map(t => {
                const st = STATUS_META[t.status] || STATUS_META.op_schema;
                return (
                  <div key={t._id} className={`sm-taak sm-${st.cls}`}>
                    <div className="sm-taak-head">
                      <span className="sm-titel">{t.titel}</span>
                      <span className={`sm-badge ${st.cls}`}>
                        {st.label}{t.status === 'over_tijd' && t.dagenOverTijd ? ` · ${t.dagenOverTijd}d` : ''}
                      </span>
                    </div>
                    <p className="sm-omschr">{t.omschrijving}</p>
                    <div className="sm-meta">
                      <span className="sm-freq">{t.frequentieLabel}</span>
                      <span className="sm-laatst">{t.laatstGedaan ? `Laatst gedaan: ${fmtDatum(t.laatstGedaan)}` : 'Nog nooit afgevinkt'}</span>
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </BeheerdersportaalSidebar>
  );
};

export default SchoonmaakAdmin;
